import React, { useState, useEffect } from 'react';

export function EmptyView() {
    return null
}